import { httpGet, post } from "@/utils/request";

export default {
  /* 高手排行 - 热度榜
  https://apisbeta.aigupiao.com/liver/month_live/?act=search&order_type=hot_rank&source=ios
  hot_rank
  follow_nums
  vip_nums
  first_name
  rec_time
   */
  getGaoShouHot(url, params) {
    return httpGet({
      url,
      params,
    });
  },

  // 达人排行
// 热度 https://apibeta.aigupiao.com/v1/rank/talent_rank
// 活跃 https://apibeta.aigupiao.com/v1/rank/talent_hot
// 粉丝 https://apibeta.aigupiao.com/v1/rank/talent_fans
// 新人 https://apibeta.aigupiao.com/v1/rank/talent_new
  getDaRenHot(url, params) {
    return post({
      url,
      params,
    });
  },
};
